import React, {Component} from 'react';
import ContentEditable from 'react-contenteditable';
import Collapse from 'react-bootstrap/Collapse';
import 
  APP_CONSTANTS,
  { DATA_OBJECT_TYPES, 
    DATA_OBJECT_TYPE_TAG,
    MULTISELECT_SUMTOTAL_ATTRIBUTE,
    MULTISELECT_CSLIST_ATTRIBUTE
} from '../shared/constants/app_constants';

/**
 * TODO:
 * #1  - FEATURE: put cursor back where it was after adding a variable or operation
 *      -this is an issue related to the ContentEditable component and the caret related function
 * #3 - REFACTOR: change on mouse down event, move function when delete var button is clicked
 * #4 - FEATURE: validate expression, check to see if expression is valid, i.e.:
 *      each opening parentheses has closing, 
 *      operation has number or var before and after
 * #8 - FEATURE: pull in font awesome for icons
 */

const postOpModifierOptions = [
  {value: 'round'},
  {value: 'floor'},
  {value: 'ceiling'},
  {value: 'truncate'}
];

const VALID_DATA_OBJECT_TYPES = [DATA_OBJECT_TYPES.FORM_ATTRIBUTE, DATA_OBJECT_TYPES.METADATA_TYPE];

class ExpressionEditor extends Component {
  contentEditableId = "expression-editor-container";

  constructor(props){
    super(props);
    //allow prop for 
    this.state = {
      editorContent: props.form_rule.nocode_expression || ' ',
      lastKeyPressed: undefined,
      showErrorForInvalidCharacter: false,
      nonKeyActionCompleted: false
    };
  }

  /**
   * returns boolean whether this dataType is compatible with target attribute
   * TODO: what do we do when dealing with multiselect?
   * @param {*} dataType - could be form attribute or metadata type
   */
  attributeCompatibleWithTarget = (dataType) => {
    switch(this.props.target_attribute.value_type){
      case APP_CONSTANTS.VALUE_TYPES.TEXT:
        return true;
      case APP_CONSTANTS.VALUE_TYPES.INTEGER:
      case APP_CONSTANTS.VALUE_TYPES.FLOAT:
        //only allow integer and float values
        return ["integer","float","currency"].includes(dataType.value_type);
      default:
        console.error('unaccounted for value type');
        return false;
    }
  }

  // TODO: edit this function to properly handle metadata
  addValueTypeToExpression = (valueType) => {
    const sel = window.getSelection();
    const editorContentRealValue              = this.state.editorContent.replace(/&nbsp;|\u202F|\u00A0/g, ' ');
    const caretIsFocusedOnContentEditable     = !!(sel.anchorNode && sel.anchorNode.parentElement && sel.anchorNode.parentElement.id === this.contentEditableId);
    let manageOffsetWithPreviousSibling       = false;
    let previousSiblingElement;
    if (caretIsFocusedOnContentEditable && sel.anchorNode && sel.anchorNode.previousElementSibling){
      //TODO check if this string contains a sibling html fragment
      const thisPreviousSiblingElement = sel.anchorNode.previousElementSibling;
      if (thisPreviousSiblingElement.className === "fa-var"){
        manageOffsetWithPreviousSibling = true;
        previousSiblingElement = thisPreviousSiblingElement;
      }
    }
    const contentEditableIsHighlighted        = !!(caretIsFocusedOnContentEditable && sel.baseOffset !== sel.focusOffset);
    const caretAtEndOfContentEditable         = caretIsFocusedOnContentEditable && (editorContentRealValue.length === sel.focusOffset);
    const insertAttributeAtCaret              = (
      caretIsFocusedOnContentEditable                 //
      && manageOffsetWithPreviousSibling === false    //the editorContent should have no html fragments for this to be false
      && sel.baseOffset === sel.focusOffset           //nothing is highlighted
    );

    const newValueTypeFragment = this.getDataAttributeFragment(valueType);
    switch(true){
      case manageOffsetWithPreviousSibling:
        this.addFormAttributeAfterSibling(valueType, sel, previousSiblingElement);
        break;
      case contentEditableIsHighlighted:
        const editorContentStr = `${this.state.editorContent}`;
        const strArr = [editorContentStr.slice(0, sel.baseOffset), newValueTypeFragment, editorContentStr.slice(sel.focusOffset + 1)];
        this.setState({
          editorContent: strArr.join("")
        });
        break;
      case insertAttributeAtCaret:
        //TODO if there is a html node in here there is a case that the fa was not added after sibling node
        //most likely this needs to be offset from begining
        const editorContent = `${this.state.editorContent}`;
        const position = sel.baseOffset;
        this.setState({
          editorContent: [editorContent.slice(0, position), newValueTypeFragment, editorContent.slice(position)].join("")
        });
        break;
      case !caretIsFocusedOnContentEditable:
        this.setState({
          editorContent: (this.state.editorContent + newValueTypeFragment),
        });
        break;
      case caretAtEndOfContentEditable:
        this.setState({
          editorContent: (this.state.editorContent + newValueTypeFragment)
        });
        break;
      default:
        console.error('did something go wrong?');
        break;
    }
  }

  //TODO: still need to fix issue related to multiple variables used more than once
  //TOOD: still having issues with caret moving around
  addFormAttributeAfterSibling = (formAttribute, selection, previousSiblingElement) => {
    const closingSpanTag = "</span>";
    const domElementId = previousSiblingElement.id;
    const indexOfTagStart = this.state.editorContent.indexOf(`<span id="${domElementId}"`);
    const indexOfTagEnd = this.state.editorContent.indexOf(closingSpanTag, indexOfTagStart);
    const indexOfSlice = indexOfTagEnd + closingSpanTag.length + selection.baseOffset;
    const editorContentStr = `${this.state.editorContent}`;
    const newFormAttributeSegment = this.getDataAttributeFragment(formAttribute);
    const fragmentArr = [editorContentStr.slice(0, indexOfSlice), newFormAttributeSegment, editorContentStr.slice(indexOfSlice)];
    this.setState({
      editorContent: fragmentArr.join("")
    });
  }

  clearEditorContent = () => {
    this.setState({ editorContent: " " });
  }

  createMarkup = (htmlString) => {
    return {__html: htmlString};
  }

  deleteFormAttributeFromEditor = (targetElement) => {
    const parentNode = targetElement.parentNode;
    let resetEditor = false;

    // DEPRECATED - this is legacy functionality, hopefully this will be deletable
    if (parentNode.getAttribute('data-type') === "form-attribute" ){ // we use data type for deletion, but this isnt just a form-attribute
      resetEditor = true;
      parentNode.remove();
    } else {
      const grandparentNode = parentNode.parentNode;
      if (grandparentNode.getAttribute('data-type') === "form-attribute" ){ // we use data type for deletion, but this isnt just a form-attribute
        resetEditor = true;
        grandparentNode.remove();
      }
    }

    // dont know why were doing this anymore
    let dataObjectType = parentNode.getAttribute(DATA_OBJECT_TYPE_TAG);
    if (dataObjectType && VALID_DATA_OBJECT_TYPES.includes(dataObjectType)){
      resetEditor = true;
      parentNode.remove();
    } else {
      // delete the grandparent?
      const grandparentNode = parentNode.parentNode;
      console.log('cannot find grandparent node to remove');
      if ( !!grandparentNode ) {
        dataObjectType = grandparentNode.getAttribute(DATA_OBJECT_TYPE_TAG);
        if (dataObjectType && VALID_DATA_OBJECT_TYPES.includes(dataObjectType)) {
          resetEditor = true;
          grandparentNode.remove();
        }
      }
    }

    if (resetEditor){
      const editorContainer = document.getElementById("expression-editor-container");
      let editorContentStr = "";
      if (editorContainer !== null){
        editorContentStr = editorContainer.innerHTML;
      }
      this.setState({
        editorContent: editorContentStr
      });
    }
  }

  // TODO: modify this to handle adding form attributes AND metadata types
  // TODO: fix this to add FA uuid AND metadata uuid or name
  getDataAttributeFragment = (valueObject) => {
    let subTypeTag = "";
    if ( valueObject.form_attribute_display_type === APP_CONSTANTS.DISPLAY_TYPES_HTML.CHECKBOX || valueObject.display_type === APP_CONSTANTS.DISPLAY_TYPES_HTML.CHECKBOX ){
      switch(valueObject.value_type){
        case APP_CONSTANTS.VALUE_TYPES.INTEGER:
        case APP_CONSTANTS.VALUE_TYPES.FLOAT:
        case APP_CONSTANTS.VALUE_TYPES.CURRENCY:
          subTypeTag = `data-value-subtype="${MULTISELECT_SUMTOTAL_ATTRIBUTE}" `;
          break;
        case APP_CONSTANTS.VALUE_TYPES.TEXT:
          subTypeTag = `data-value-subtype="${MULTISELECT_CSLIST_ATTRIBUTE}" `;
          break;
        default:
          console.warn('this should not happen - missing value type for metadata');
      }
    }
    const uniqueId = this.getRandomNumber();
    let valueObjectName = valueObject.name;
    if (valueObject.object_type === DATA_OBJECT_TYPES.METADATA_TYPE) {
      valueObjectName = valueObject.label;
    }

    const daFragment = ` <span id="fa-${uniqueId}" ` +
      `data-var-id="${valueObject.id}" ` +                        // we want to keep this now
      `data-fa-id="${valueObject.form_attribute_id}" ` +          // KEEP THIS!
      `data-fa-uuid="${valueObject.form_attribute_uuid}" ` +      // this is new, the hope is to migrate to all uuids
      `data-var-uuid="${valueObject.uuid}" ` +                    // every piece of data should have a uuid
      `${DATA_OBJECT_TYPE_TAG}="${valueObject.object_type}" ` +   // could be form attribute or metadata - eventually add system?
      // `data-type='form-attribute' ` +                          // THIS HAS BEEN DEPRECATED - will not appear in editor in the future
      `class='fa-var' ` +                                         // for CSS, although this isnt exclusive to form attributes anymore
      subTypeTag +                                                // for things like multselec subtotals
      `contenteditable=false ` +                                  // this is required, keep it
      `>${valueObjectName} ` +                                  // yeah this is good
        `<button ` +                                              // keep it
        `class="btn btn-secondary btn-sm btn-xs" ` +              // keep it
        `type="button" data-action="delete-fa" ` +                // maybe we change this?
        `data-var-id="${valueObject.id}" ` +                      // 
        `data-var-uuid="${valueObject.uuid}" ` +
        `>` +
        `<i class="fas fa-times" data-action="delete-fa"></i>` +
        `</button>` +
      `</span> `;
    return daFragment;
  }

  getRandomNumber = () => {
    return Math.ceil(Math.random() * 100000);
  }

  getEligbleFormAttributesForEditor = () => {
    //this depends on the target attribute
    let eligbleDataItems = [];
    this.props.keenform.form_attributes.forEach((fa) => {
      const formAttribute = {
        ...fa,
        object_type: 'form_attribute',
        form_attribute_id: fa.id,
        form_attribute_uuid: fa.uuid,
      };
      if (this.attributeCompatibleWithTarget(fa)){
        eligbleDataItems.push(formAttribute);
      }
      if (fa.metadata_types){
        fa.metadata_types.forEach(mdt => {
          // TODO: this code smells
          // confession - I did this for data parity between form attributes and metadata
          // we all make compromises right?
          const metadataTypeAsFA = {
            ...mdt,
            label: `${fa.name}.${mdt.name}`,
            object_type: DATA_OBJECT_TYPES.METADATA_TYPE,
            fa_uuid: fa.uuid,
            form_attribute_name: fa.name,
            form_attribute_display_type: fa.display_type,
            form_attribute_id: fa.id,
            form_attribute_uuid: fa.uuid,
          };
          if (this.attributeCompatibleWithTarget(metadataTypeAsFA)){
            eligbleDataItems.push(metadataTypeAsFA);
          }
        })
      }
    });
    return eligbleDataItems;
  }

  handleChangeToEditor = (event) => {
    if (this.props.valid_character_set){
      if (this.props.valid_character_set.includes(this.state.lastKeyPressed)){
        const newEditorContent = event.target.value.replace(/&nbsp;|\u202F|\u00A0/g, ' ');
        this.setState({editorContent: newEditorContent});
      } else {
        console.error('invalid character pressed');
        this.setState({
          editorContent: this.state.editorContent,
          showErrorForInvalidCharacter: true
        });
      }
    } else {
      //no validation required
      const newEditorContent = event.target.value.replace(/&nbsp;|\u202F|\u00A0/g, ' ');
      this.setState({editorContent: newEditorContent});
    }

  };

  onKeyDownEvent = (event) => {
    this.setState({
      lastKeyPressed: event.key
    });
  }

  onMouseDownEvent = (event)=> {
    const targetElement = event.target;
    const isDeleteAction = (targetElement.getAttribute('data-action') === "delete-fa"); // TODO: change this to make it more generic, no delete-fa but maybe delete-vo
    if (isDeleteAction){
      this.deleteFormAttributeFromEditor(targetElement);
    } else {
      console.log('dont do anything');
    }
  }

  //TODO: THIS DOESNT WORK YET AND should not be used until issue is resolved
  placeCaretAfterFormAttribute(uuid){ 
    const el = document.getElementById(this.contentEditableId);
    if (el !== null){
      let matchingNodeIndex = null;
      Array.from(el.children).forEach((thisNode, index) => {
        //TODO find node with this data-var-uuid === uuid
        if (thisNode.nodeName === "SPAN"){
          const thisUUID = thisNode.getAttribute('data-var-uuid');
          if (thisUUID && thisUUID === uuid ) {
            matchingNodeIndex = index;
            //TODO: put cursor after this node
          }
        }
      });
      
      //TODO: instead of appendChild, use insertBefore unless this is the last item
      if (matchingNodeIndex !== null){
        const target = document.createTextNode(' ');
        el.appendChild(target);
        const range = document.createRange();
        const sel = window.getSelection();
        if ( sel !== null){
          range.setStart(el.children[matchingNodeIndex], 0);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
          el.focus();
        }
      }
    }
  }

  //TODO rename this to remove not just variables but also math functions
  removeFormAttributeFromEditor(event) {
    //TODO: place caret in correct place after adding form attribute
    const buttonParentNode = event.target.parentNode;
    buttonParentNode.remove();
    //get text of expression-editor-container
    const editorContainer = document.getElementById("expression-editor-container");
    let editorContentStr = "";
    if (editorContainer !== null){
      editorContentStr = editorContainer.innerHTML;
    }
    this.setState({
      editorContent: editorContentStr
    });
  }
  
  render() {
    let targetAttribute;
    if ( this.props.form_rule 
      && this.props.form_rule.target_attributes
      && this.props.form_rule.target_attributes.length === 1 ) {
      targetAttribute = this.props.form_rule.target_attributes[0];
    }
    const attributeValueArray = this.getEligbleFormAttributesForEditor();
    return (<div className="expression-editor-wrapper">
      <div className="content-editable-wrapper">
        <div
          className="expression-placeholder">
            {this.props.topNote}
        </div>
        <div className="expression-editor-row">
          <div className="content-editable-row">
            <ContentEditable
              id={this.contentEditableId}
              // innerRef={this.contentEditableRef}
              html={this.state.editorContent}
              onKeyDown={ (event) => {this.onKeyDownEvent(event)} }
              onMouseDown={ (event) => {this.onMouseDownEvent(event)}}
              onChange={ (event) => {this.handleChangeToEditor(event)} } />
            <div>
              <button
                className="btn btn-circle btn-danger"
                type="button"
                onClick={() => {this.clearEditorContent()}} >
                <i className="far fa-times-circle"></i>
              </button>
            </div>
            <input type='hidden' name='form_rule[nocode_expression]' value={this.state.editorContent} />
            <input type='hidden' name='form_rule[use_nocode_expression]' value="1" />
          </div>
          { targetAttribute.value_type === "integer" || targetAttribute.value_type === "float"
            ? <div className='form-group'>
                <label>Post Operation Modifier: </label>
                <select
                  className='form-control'
                  defaultValue={this.props.form_rule.post_op_modifier}
                  name="form_rule[post_op_modifier]">
                  {postOpModifierOptions.map((modifier, index) => <option key={index} value={modifier.value}>{modifier.value}</option>)}
                </select>
              </div>
            : undefined
          }
        </div>
        <Collapse in={this.state.showErrorForInvalidCharacter}>
          <div className="alert alert-danger" role="alert">
            The expression editor only accepts the following characters 0-9 . + - * / ( ) and variables/functions added via buttons
          </div>
        </Collapse>
      </div>
      <div className="row">
        <div className="col-6 embeddable-form-attributes-col">
          <h5><strong>FORM ATTRIBUTES</strong></h5>
          <div className="form-attributes-scroll-container">
          { 
            attributeValueArray.map( (variable, index) => {
              // use name of fa, unless its metadata, then use label instead
              let displayLabel = variable.name;
              if (variable.object_type === DATA_OBJECT_TYPES.METADATA_TYPE) {
                displayLabel = variable.label;
              }
              if (variable.display_type === "checkbox" || variable.form_attribute_display_type === "checkbox"){ // TODO: this is shit code
                displayLabel += " (sum of selected)";
              }
              return (<button type="button"
                key={index}
                className="btn btn-outline-info btn-block" 
                onClick={(event)=> {
                  this.addValueTypeToExpression(variable);
                } }><i className="fas fa-plus"></i> {displayLabel}
              </button>);
            })
          }
          </div>
        </div>
        <div className="col-6 editor-notes-col">
          {this.props.sideNote}
        </div>
      </div>
      <hr />

      { targetAttribute.value_type === "text" ?
      <div className="row">
        <label className="col-form-label col-sm-4">Format numbers for display</label>
        <div className="col-sm-8">
          <input type="hidden" name="form_rule[format_numbers_for_display]" value="0" />
          <input 
            type="checkbox"
            className="form-control"
            value="1"
            defaultChecked={this.props.form_rule.format_numbers_for_display}
            name="form_rule[format_numbers_for_display]" />
        </div>
      </div> : undefined
      }
    </div>);
  }
}

export default ExpressionEditor;